export const LogoutIcon = ({ style }) => (
  <svg viewBox="0 0 24 24" style={style}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.25 2C2.55964 2 2 2.55964 2 3.25V20.75C2 21.4404 2.55964 22 3.25 22H10.75C11.4404 22 12 21.4404 12 20.75C12 20.0596 11.4404 19.5 10.75 19.5H4.5V4.5H10.75C11.4404 4.5 12 3.94036 12 3.25C12 2.55964 11.4404 2 10.75 2H3.25Z"
      fill="currentColor"
    ></path>
    <path
      d="M16.1161 7.36612C16.6043 6.87796 17.3957 6.87796 17.8839 7.36612L21.6339 11.1161C21.7483 11.2305 21.8359 11.3616 21.8967 11.5015L21.9052 11.5215C21.9663 11.6689 22 11.8305 22 12C22 12.1695 21.9663 12.3311 21.9052 12.4785C21.8442 12.6259 21.7537 12.764 21.6339 12.8839L17.8839 16.6339C17.3957 17.122 16.6043 17.122 16.1161 16.6339C15.628 16.1457 15.628 15.3543 16.1161 14.8661L17.7322 13.25H9.5C8.80964 13.25 8.25 12.6904 8.25 12C8.25 11.3096 8.80964 10.75 9.5 10.75H17.7322L16.1161 9.13388C15.628 8.64573 15.628 7.85427 16.1161 7.36612Z"
      fill="currentColor"
    ></path>
  </svg>
);
